module.exports = __webpack_public_path__ + "54f7adbed168c2da3bac8e2869a228b1.pdf";